//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CatIcon } from 'counselor-mobile-ui'

/**
     * 1待审批
     * 2催办
     * 3已审批
     * 4已驳回
     * 5即将休假
     * 6休假中
     * 7销假逾期
     * 8完成:不离校、离校销假
     * 9当前流程整个节点没有老师，直接审批通过
     * 10未审批逾期30天自动驳回
     */
const statuFlagsObj = {
  flag5: {
    bg: 'flag-warning',
    boldText: '即将休假',
    svgText: '审批已通过',
    isPass: true,
  },
  flag6: {
    bg: 'flag-success',
    boldText: '正在休假中',
    svgText: '审批已通过',
    isPass: true,
  },
  flag7: {
    bg: 'flag-error',
    boldText: '销假逾期',
    svgText: '审批已通过',
    isPass: true,
  },
  flag8: {
    bg: 'flag-grey',
    boldText: '已完成',
    svgText: '审批已通过',
    isPass: true,
  },
  flag4: {
    bg: 'flag-error',
    boldText: '已驳回',
    svgText: '审批已驳回',
    isPass: false,
  },
  flag10: {
    bg: 'flag-error',
    boldText: '已驳回',
    svgText: '审批已驳回',
    isPass: false,
  },
  flag100: {
    bg: 'flag-grey',
    boldText: '已过期',
    svgText: '审批已通过',
    isPass: true,
  },

}

export default {
  components: { CatIcon },

  props: {
    flag: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '2020-10-12 14:42',
    },

    isShow: {
      type: Boolean,
      default: true,
    },

    firstIdx: {
      type: Boolean,
      default: false,
    },

    // 是否展示二维码
    isShowQrNoApproval: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    bg () {
      return statuFlagsObj[`flag${this.flag}`].bg
    },

    boldText () {
      if (+this.flag === 100 && this.firstIdx && this.isShowQrNoApproval) {
        return statuFlagsObj.flag8.boldText
      } else {
        return statuFlagsObj[`flag${this.flag}`].boldText
      }
    },

    svgText () {
      return statuFlagsObj[`flag${this.flag}`].svgText
    },

    isPass () {
      return statuFlagsObj[`flag${this.flag}`].isPass
    },
  },

  methods: {
    showInfoModal () {
      this.$emit('show-info')
    },
  },
}
